import { HttpApiService } from "@/shared/services/httpApi.service";

import { ORGANIZATIONS_API_ENDPOINTS } from "../constants/organizations.constants";
import type { CardStylesConfig } from "../types/branding.types";

export class BrandingService {
  private static cardStylesUrl(orgId: string): string {
    return `${ORGANIZATIONS_API_ENDPOINTS.ORGANIZATIONS}/${orgId}/card-styles`;
  }

  static async getCardStyles(orgId: string): Promise<CardStylesConfig | null> {
    const response = await HttpApiService.get<CardStylesConfig | null>(BrandingService.cardStylesUrl(orgId));
    return response.data ?? null;
  }

  static async updateCardStyles(orgId: string, patch: CardStylesConfig): Promise<CardStylesConfig> {
    const response = await HttpApiService.patch<{
      card_styles_config?: CardStylesConfig;
    }>(BrandingService.cardStylesUrl(orgId), patch);
    return response.data.card_styles_config ?? {};
  }

  static async uploadLogo(orgId: string, file: File): Promise<{ url: string }> {
    const formData = new FormData();
    formData.append("logo", file);

    const response = await HttpApiService.post<{ url: string }>(
      `${BrandingService.cardStylesUrl(orgId)}/logo`,
      formData,
    );
    return response.data;
  }
}
